import React from 'react';
import cn from 'classnames';
import { bbCodeToHtml } from '../../../../../../../../../utils/formUtils';
import Icon from '../../../../../../../../../components/common/icon';
import Button, {
  ButtonType,
} from '../../../../../../../../../components/common/button';
import { Visibility } from '../../../../../../../../../types/common-types';
import './style.scss';

interface LoanValue {
  totalAmount: string;
  dueDate: string;
}
interface Labels {
  totalAmount: string;
  dueDate: string;
  actionLabel: string;
  actionButton: string;
}
interface Props {
  id: string;
  visibility?: Visibility;
  error?: boolean;
  value: LoanValue;
  extra: {
    labels: Labels;
    inTermination: boolean;
    visibility: { actionButton?: Visibility };
  };
  onSubmit: (id: string) => void;
}

const LoanInfo: React.FC<Props> = ({
  id,
  visibility,
  extra,
  error = false,
  value,
  onSubmit,
}) => {
  const { labels, inTermination, visibility: extraVis = {} } = extra;
  const { actionButton: actionButtonVisibility } = extraVis;
  const {
    totalAmount: totalAmountLabel,
    dueDate: dueDateLabel,
    actionLabel,
    actionButton,
  } = labels;
  const { totalAmount, dueDate } = value;
  return (
    <div
      id={id}
      data-cy="loanInfo"
      styleName={cn('info', {
        hidden: visibility === Visibility.Hidden,
        error,
      })}
    >
      <div styleName="info__total">
        <div styleName="info__title">{totalAmountLabel}</div>
        <div styleName="info__circle">
          <div
            styleName="info__label" // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: bbCodeToHtml(totalAmount),
            }}
          />
        </div>
      </div>
      <div styleName="info__row">
        {inTermination ? (
          ''
        ) : (
          <div styleName="info__date">
            <div styleName="info__date__label">{dueDateLabel}</div>
            <Icon styleName="info__date__icon" value="calendar" />
            <div styleName="info__date__label">{dueDate}</div>
          </div>
        )}
        <div styleName={inTermination ? 'info__terminated' : 'info__defer'}>
          <div styleName="info__defer__label">{actionLabel}</div>
          <Button
            id="deferButton"
            type={ButtonType.Submit}
            error={error}
            visibility={actionButtonVisibility}
            label={actionButton}
            onClick={() => {
              onSubmit(id);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoanInfo;
